import { AfterViewInit, Directive, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, NgControl, NgModel } from '@angular/forms';

@Directive({
    selector: '[gmAutoComplete]',
    providers: [NgModel],
})
export class GMAutoComplete implements AfterViewInit, OnChanges {
    @Output() setAddress: EventEmitter<any> = new EventEmitter();
    @Input() ngModel: string;
    @Output() ngModelChange: EventEmitter<any> = new EventEmitter();

    constructor(private el: ElementRef,
        private ac: NgControl
    ) {

    }

    ngAfterViewInit() {
        this.getPlaceAutocomplete();
        setTimeout(() => {
            this.ac.control.updateValueAndValidity();
        }, 100);
    }

    private clear(): void {
        this.thisPlace = null;
        setTimeout(() => {
            this.setAddress.emit(null);
            setTimeout(() => {
                this.ac.control.updateValueAndValidity();
            }, 100);
        });
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['ngModel']) {
            if (this.thisPlace) {
                if (this.thisPlace.formatted_address !== changes['ngModel'].currentValue) {
                    this.clear();
                }
            } else {
                this.clear();
            }
        }
    }

    private thisPlace: google.maps.places.PlaceResult;
    private getPlaceAutocomplete() {
        const autocomplete = new google.maps.places.Autocomplete(this.el.nativeElement,
            {
                componentRestrictions: { country: 'US' },
                types: ['geocode']  // 'establishment' / 'address' / 'geocode'
            });


        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            const place = autocomplete.getPlace();
            this.thisPlace = place;
            this.setAddress.emit(place);
            setTimeout(() => {
                this.ac.control.updateValueAndValidity();
            }, 100);
        });
    }
}